// import { DotLottie } from '@lottiefiles/dotlottie-web';
// import '@lottiefiles/dotlottie-wc';
// import '@aarsteinmedia/dotlottie-player-light'

// CUSTOM JS.

// Moved to parent theme.
// Add an optimized resize event.
// (function() {
// 	var throttle = function(type, name, obj) {
// 		obj = obj || window;
// 		var running = false;
// 		var func = function() {
// 			if (running) { return; }
// 			running = true;
// 				requestAnimationFrame(function() {
// 					obj.dispatchEvent(new CustomEvent(name))
// 					running = false;
// 			});
// 		};
// 		obj.addEventListener(type, func)
// 	};

// 	throttle("resize", "optimizedResize")
// })();
// Usage example: Recalculate on resize
// window.addEventListener("optimizedResize", function() {
// 	window.setTimeout( ()=>{
// 		console.log( 'optimized resize called!')
// 	}, 100)
// });



// Helper function, check if referrer is from the same origin.
// @see old one: https://stackoverflow.com/questions/4362761/how-can-i-determine-if-the-document-referrer-is-from-my-own-site.
function inzms_ib_check_referrer_same_origin() {
    try {
        const referrer = new URL(document.referrer);
        return (referrer.origin === location.origin);
    } catch(invalid_url_error) {
        return false;
    }
}




// Initial setup on Load.
// In order of need.
document.addEventListener('DOMContentLoaded', (event) => {
	console.log( 'JS child theme for DCO Websites loaded.' )


	// Moved to parent theme.
	// const html = document.querySelector('html');
	// const body = document.querySelector('body');
	// html.classList.remove('no-js')
	// html.classList.add('js')


	// Replace video play buttons.
	// const videoPlayButtons = document.querySelectorAll('.hd-bcve-wrapper .play-button')
	// if (videoPlayButtons) {
	// 	videoPlayButtons.forEach(element => {
	// 		let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
	// 		let use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
	// 		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#ib_play_btn');
	// 		svg.append(use)
	// 		svg.classList.add('svg-icon')
	// 		svg.setAttribute('aria-hidden', 'true')
	// 		element.append(svg)
	// 	})
	// }

	// Make buttons equal-width (per group of btns).
	const equalWidthButtonGroups = document.querySelectorAll('.is-style-equal-width-btns')
	if (equalWidthButtonGroups) {

		equalWidthButtonGroups.forEach(equalWidthButtonGroup => {
			let maxBtnLinkWidth = 0;

			const buttonsWithinGroup = equalWidthButtonGroup.querySelectorAll('.wp-block-button__link')
			if (buttonsWithinGroup) {
				buttonsWithinGroup.forEach(btn => {

					const buttonLinkWidth = btn.offsetWidth;

					console.log(buttonLinkWidth)
					if (buttonLinkWidth > maxBtnLinkWidth) {
						maxBtnLinkWidth = buttonLinkWidth;
					}

				})

				console.log('max: ' + maxBtnLinkWidth);
				equalWidthButtonGroup.style.setProperty('--max-link-width', maxBtnLinkWidth + 'px');
			}
		})
	}

})



